import React from 'react';

export const HardwareSection = () => {
  return (
    <section className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="flex justify-center">
            <img
              src="/terminal3d.png"
              alt="PAX A960 terminal med MUSEIQ interface"
              className="w-full max-w-sm object-contain"
            />
          </div>

          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-primary mb-6">
              Software i centrum – hardware som en del af løsningen
            </h2>

            <p className="text-lg text-body leading-relaxed mb-6">
              MUSEIQ er en softwareplatform til betalinger og salg. Terminaler leveres gennem vores partner S5 med stabile enheder som PAX A960.
            </p>

            <p className="text-lg text-body leading-relaxed mb-8">
              Det giver en fleksibel løsning, hvor software og hardware fungerer som en samlet platform.
            </p>

            <div className="rounded-2xl bg-section-bg p-6 mb-8">
              <h3 className="text-xl font-semibold text-primary mb-3">
                Stabil drift - også offline
              </h3>
              <p className="text-lg text-body leading-relaxed">
                MUSEIQ kan håndtere betalinger selv ved ustabil forbindelse, så salget fortsætter uden afbrydelser.
              </p>
            </div>

            <div className="flex items-center gap-8">
              <div className="text-sm font-semibold text-body/70 uppercase tracking-wide">
                Indløsningsaftale via S5
              </div>
              <div className="text-sm font-semibold text-body/70 uppercase tracking-wide">
                PAX A960
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
